﻿﻿﻿<div class="container-tab-lists">
    <controllertypebytenant-menu (onRefresh)="refreshAll()"></controllertypebytenant-menu>
    <div class="inner-tcontainer-tab">
        <div class="tab-body">
            <div class="tab-content">
                <controllertypebytenant-list [list]="controllertypebytenant" (onRefresh)="refreshAll()"></controllertypebytenant-list>
            </div> <!--tab-content-->
        </div> <!--tab-body-->
    </div> <!--inner-tcontainer-tab-->
</div> <!--container-tab-lists-->